import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import { Input } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const PaginationGroup = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseFilter } = props;
    const [offset, setOffset] = useState('');
    const [limit, setLimit] = useState('');
    const checkInput = (value) => {
        let v = value;
        if (typeof v === 'string') {
            v = parseInt(v);
        }
        if (isNaN(v) || v < 0 || v.toString().includes('e')) {
            return '';
        }
        return v;
    };
    return (React.createElement(FilterGroup, { name: lang.caseFilter.pagination },
        React.createElement(FilterOption, { active: !!caseFilter.offset, header: lang.caseFilter.offset, subheader: lang.caseFilter.offsetExplanation, onDeactivate: () => c.insights.clearFilter('offset') },
            React.createElement(Input, { type: "number", min: 0, placeholder: lang.caseFilter.offset, value: offset, onChange: async (e) => {
                    const v = e.target.value;
                    setOffset(checkInput(v));
                    if (!isNaN(parseInt(v))) {
                        c.insights.updateFilter({
                            offset: parseInt(v),
                        });
                    }
                }, style: { marginBottom: '0' } })),
        React.createElement(FilterOption, { active: !!caseFilter.limit, header: lang.caseFilter.limit, subheader: lang.caseFilter.limitExplanation, onDeactivate: () => c.insights.clearFilter('limit') },
            React.createElement(Input, { type: "number", min: 0, placeholder: lang.caseFilter.limit, value: limit, onChange: async (e) => {
                    const v = e.target.value;
                    setLimit(checkInput(v));
                    if (!isNaN(parseInt(v))) {
                        c.insights.updateFilter({
                            limit: parseInt(v),
                        });
                    }
                }, style: { marginBottom: '0' } }))));
};
export default PaginationGroup;
//# sourceMappingURL=PaginationGroup.js.map